import { TaskId, TaskType } from '@squaredup/tasks';
import stringify from 'fast-json-stable-stringify';
import { Workspace } from 'services/WorkspaceService';
import { ADMINISTRATION, LINKING, LIST, ROLLUP, STATE } from './common';

const WORKSPACES = 'workspaces';
const COUNT = 'count';
const INCLUDE_TILE_STATES = 'includeTileStates';
const INCLUDE_DASHBOARD_NAMES = 'includeDashboardNames';
const KPIS = 'KPIS';
const AVATAR = 'avatar';
const SCHEDULED_TASKS = 'scheduledTasks';
const SMART_MONITORS = 'smartMonitors';
const UPDATE_ORDER_MUTATION = 'updateOrderMutation';
const VARIABLES = 'variables';

export const workspaceQueryKeys = {
    all: [WORKSPACES],
    list: [WORKSPACES, LIST],
    count: [WORKSPACES, COUNT],
    listDashboards: (workspaceId?: string) => [WORKSPACES, LIST, String(workspaceId)],
    forAdministration: [WORKSPACES, ADMINISTRATION],
    states: [WORKSPACES, STATE],
    stateRollups: (workspaceIds?: string[]) => [WORKSPACES, STATE, ROLLUP, stringify(workspaceIds?.sort())],
    forLinking: (workspaceId?: string | null) => [WORKSPACES, LINKING, String(workspaceId)],
    kpis: (workspaceId?: string | null, config?: { includeValues?: boolean }) => [
        WORKSPACES,
        KPIS,
        String(workspaceId),
        stringify(config)
    ],
    state: (workspaceIds?: string[], includeTileStates = false, includeDashboardNames = false) => [
        WORKSPACES,
        STATE,
        stringify(workspaceIds?.sort()),
        ...(includeTileStates ? [INCLUDE_TILE_STATES] : []),
        ...(includeDashboardNames ? [INCLUDE_DASHBOARD_NAMES] : [])
    ],
    smartMonitors: (workspaceId?: string | null) => [WORKSPACES, SMART_MONITORS, String(workspaceId)],
    avatar: (id: Workspace['id']) => [WORKSPACES, AVATAR, id],
    variables: (workspaceId?: string | null) => [WORKSPACES, VARIABLES, String(workspaceId)],
    scheduledTasks: (id: Workspace['id'], type?: TaskType) => [WORKSPACES, SCHEDULED_TASKS, id, String(type)],
    scheduledTask: (id: Workspace['id'], type: TaskType, taskId: TaskId) => [
        WORKSPACES,
        SCHEDULED_TASKS,
        id,
        type,
        taskId
    ],
    updateOrderMutation: [WORKSPACES, UPDATE_ORDER_MUTATION]
};
